export default () => {
  $(function() {
    const sidebarItems = $('.sidebar-item');
    let itemsList = '';
    const currentPage = window.location.pathname
      .replace(/\//g, ' ')
      .trim()
      .split(' ')
      .splice(-1)[0];

    if (sidebarItems.length) {
      sidebarItems.map(function() {

        const linkText = $(this).attr('data-name');
        console.log(linkText)
        const id = linkText
          .toLowerCase()
          .trim()
          .replace(/ /g, '-')
          .replace(/[^A-Za-z0-9-:]/g, '');
        const isActive = id === currentPage ? 'active' : '';
        const url = $(this).attr('data-url');
        if (url) {
          itemsList += `<li class="sidebar-option ${isActive}"><a href="${url}">${linkText}</a></li>`;
        } else {
          itemsList += `<li class="sidebar-option"><a href="#${id}">${linkText}</a></li>`;
        }
      });
      $('.navigation-sidebar')
        .append(`<ul>${itemsList}</ul>`)
        .show();
      $('.main-content').css({ display: 'flex', 'justify-content': 'space-between', width: '100%' });

      const sticky = $('.navigation-sidebar');
      const stickyStopper = $('.main-block article').height() + $('.main-block article').offset().top;
      if (sticky.offset()) {
        const generalSidebarHeight = sticky.innerHeight();
        const stickyTop = sticky.offset().top;
        const stickOffset = 40;
        const stickyStopperPosition = stickyStopper;
        const stopPoint =
          stickyStopperPosition - generalSidebarHeight - stickOffset;
        // const diff = stopPoint + stickOffset;
        const endPoint =  $('.main-block article').height() - 60 - 270//+ $('.main-block article').position().top
        const bottom = $('.main-block article').height();

        $(window).scroll(function() {
          const windowTop = $(window).scrollTop();

          
          if (stopPoint < windowTop) {
            console.log('if 1')
            sticky.css({
              position: 'absolute',
              top: stopPoint - 30 - (sticky.height / 2),
              right: '0',
              bottom: 'auto',
              transform: 'translateX(-50%)'
            });
          } else if (windowTop > endPoint) {
            console.log('if 2')
            sticky.css({
              position: 'absolute',
              bottom: '0',
              right: '0',
              top: bottom - 120,
              // transform: 'none',
            });
          } else if (stickyTop < windowTop + stickOffset) {
            console.log('if 3')
            sticky.css({
              position: 'fixed',
              top: 'initial',
              right: 0,
              bottom: 'auto',
              transform: 'translateX(-50%)'
            });
          } else {
            console.log('scrolling down')
            sticky.css({
              position: 'fixed',
              top: 'initial',
              right: 0,
              bottom: 'auto',
              transform: 'translateX(-50%)'
            });
          }
        });
      }
    }

    $('.sidebar-option').click(function(e) {
      e.preventDefault();
      $('.sidebar-option').removeClass('active');
      $(this).addClass('active');

      if ($(this).find('a').attr('href').startsWith('#')) {
        $('html, body').animate({
            scrollTop: $($(this).find('a').attr('href')).offset().top
        },
        500
      );
      } else {
        window.location.href = $(this).find('a').attr('href');
      }
    });
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/sidebar.js